import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

interface Props {
  attemptsLeft: number;
  duration?: number; // ms before disappearing
}

export default function AttemptsPopup({
  attemptsLeft,
  duration = 1000,
}: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (attemptsLeft >= 0) {
      setVisible(true);

      const timer = setTimeout(() => {
        setVisible(false);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [attemptsLeft, duration]);

  const colorClass = new Map([
    [1, "text-red-500"],
    [2, "text-orange-500"],
    [3, "text-green-500"],
  ]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key={attemptsLeft}
          initial={{ scale: 0.6, opacity: 0, y: -40 }}
          animate={{ scale: 1.3, opacity: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 40 }}
          transition={{ duration: 0.2, type: "spring" }}
          className="fixed inset-0 flex items-center justify-center pointer-events-none z-50"
        >
          <span
            className={`text-6xl font-bold  drop-shadow-lg ${colorClass.get(
              attemptsLeft
            )}`}
          >
            {attemptsLeft} {attemptsLeft > 1 ? "Attempts" : "Attempt"} Left
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
